var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMoneyRecive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 18.3334C12.6665 19.6267 13.6665 20.6667 14.8932 20.6667H17.3998C18.4665 20.6667 19.3332 19.7601 19.3332 18.6267C19.3332 17.4134 18.7998 16.9734 18.0132 16.6934L13.9998 15.2934C13.2132 15.0134 12.6799 14.5867 12.6799 13.3601C12.6799 12.2401 13.5465 11.3201 14.6132 11.3201H17.1198C18.3465 11.3201 19.3465 12.3601 19.3465 13.6534",
    stroke: "#172343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10V22",
    stroke: "#172343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 16C29.3332 23.36 23.3598 29.3333 15.9998 29.3333C8.63984 29.3333 2.6665 23.36 2.6665 16C2.6665 8.63996 8.63984 2.66663 15.9998 2.66663",
    stroke: "#172343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 4V9.33333H27.9998",
    stroke: "#172343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 2.66663L22.6665 9.33329",
    stroke: "#172343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoneyRecive);
export default __webpack_public_path__ + "static/media/ic_money-recive.65d70b30ae58a2154d2133baa229b701.svg";
export { ForwardRef as ReactComponent };